import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const MinusCircleFillSmall = (props: SvgIconT.Props) => (
  <SvgIcon width={24} {...props} viewBox="0 0 24 24">
    <path d="M11.5 4C7.375 4 4 7.375 4 11.5S7.375 19 11.5 19s7.5-3.375 7.5-7.5S15.625 4 11.5 4zm4.5 8H7v-1h9v1z"></path>
  </SvgIcon>
);

export default MinusCircleFillSmall;
